export default __webpack_public_path__ + "static/media/cards.1fcb841a.png";